module.exports = __webpack_public_path__ + "static/moss_road-64531390b977e8a9f6d10b415c377a73.jpg";